import { observable, action } from 'mobx';

// 地磁工作模式
export const WORK_MODE = {
  hibernate: {
    code: 40,
    mode: 'HYBN', // 冬眠
    desc: '冬眠'
  },
  zzz: {
    code: 60,
    mode: 'ZZZ', // 休眠
    desc: '休眠'
  },
  work: {
    code: 50,
    mode: 'WORK', // 工作
    desc: '工作'
  },
  frozen: {
    code: 20,
    mode: 'FROZ', // 仓储
    desc: '仓储'
  },
  install: {
    code: 30,
    mode: 'INSTALL', // 安装调试
    desc: '安装调试'
  },
  assem: {
    code: 10,
    mode: 'ASSEM', // 生产
    desc: '生产'
  },
};

export default class WordModeStore {
  @observable oldMode = '';

  @observable status = 'default';

  @action setOldMode(code) {
    this.oldMode = code;
  }
}

export const workModeStore = new WordModeStore();
